import * as tslib_1 from "tslib";
import { setMailboxMessageConfiguration } from 'owa-options-core';
import store from '../store/store';
import { getUserConfiguration } from 'owa-session-store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(action('saveReadReceiptOption')(function saveReadReceiptOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions, optionId;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    userOptions.ReadReceipt = optionState.readReceiptResponse;
                    switch (optionState.readReceiptResponse) {
                        case 'DoNotAutomaticallySend':
                            optionId = 0;
                            break;
                        case 'AlwaysSend':
                            optionId = 1;
                            break;
                        case 'NeverSend':
                            optionId = 2;
                            break;
                    }
                    return [4 /*yield*/, setMailboxMessageConfiguration({
                            ReadReceiptResponse: optionId,
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveReadReceiptOption.js.map